import { render, staticRenderFns } from "./CommentArchive.vue?vue&type=template&id=d90cf322&scoped=true&"
import script from "./CommentArchive.vue?vue&type=script&lang=js&"
export * from "./CommentArchive.vue?vue&type=script&lang=js&"
import style0 from "./CommentArchive.vue?vue&type=style&index=0&id=d90cf322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90cf322",
  null
  
)

export default component.exports